export class Manager {
    constructor(actions) {
        this.actions = {};
        this.actions = actions;
    }
    handleMessage(message) {
        const func = this.actions[message.type];
        func(message);
    }
}
//hacia el worker
export class ConsumerManager extends Manager {
    constructor() {
        super(...arguments);
        this.port = null;
    }
    assignPort(port) {
        this.port = port;
        port.onmessage = (e) => {
            this.handleMessage(e.data);
        };
    }
    startLog() {
        var _a;
        const message = { currentDate: new Date(), type: "LogStart" };
        (_a = this.port) === null || _a === void 0 ? void 0 : _a.postMessage(message);
    }
    updateWorker() {
        var _a;
        const message = { currentDate: new Date(), type: "LogUpdate" };
        (_a = this.port) === null || _a === void 0 ? void 0 : _a.postMessage(message);
    }
    stopLog() {
        var _a;
        const message = { currentDate: new Date(), type: "LogStop" };
        (_a = this.port) === null || _a === void 0 ? void 0 : _a.postMessage(message);
    }
    initWorker(ruta, idHistorial, tiempoActualizar, tiempoMaximoInactividad) {
        var _a;
        const message = {
            ruta,
            idHistorial: idHistorial,
            tiempoActualizar: tiempoActualizar,
            tiempoMaximoInactividad: tiempoMaximoInactividad,
            type: "Init",
        };
        (_a = this.port) === null || _a === void 0 ? void 0 : _a.postMessage(message);
    }
    requestLog(idJornada) {
        var _a;
        const message = { idJornada: idJornada, type: "LogRequest" };
        (_a = this.port) === null || _a === void 0 ? void 0 : _a.postMessage(message);
    }
    PingLog() {
        var _a;
        const message = { type: "Ping" };
        (_a = this.port) === null || _a === void 0 ? void 0 : _a.postMessage(message);
    }
}
//desde el worker
export class WorkerManager extends Manager {
    constructor() {
        super(...arguments);
        this.ruta = "";
        this.idHistorial = 0;
        this.ports = [];
    }
    addPort(port) {
        if (!this.ports.find((p) => p == port)) {
            this.ports.push(port);
            port.onmessage = (e) => {
                this.handleMessage(e.data);
            };
        }
    }
    sendErrorMessage(errorMessage) {
        const message = {
            message: errorMessage,
            type: "LogErrorMessage",
        };
        this.ports.forEach((p) => p.postMessage(message));
    }
    sendLogStarted(idHistorial, date, messageWorker) {
        const message = {
            idHistorial: idHistorial,
            date: date,
            message: messageWorker,
            type: "LogStarted",
        };
        this.ports.forEach((p) => p.postMessage(message));
    }
    sendLogFinished(date, interval, messageWorker) {
        const message = {
            date: date,
            interval: interval,
            message: messageWorker,
            type: "LogFinished",
        };
        this.ports.forEach((p) => p.postMessage(message));
    }
    sendLogFinishedInactivity(date, interval, messageWorker) {
        const message = {
            date: date,
            interval: interval,
            message: messageWorker,
            type: "LogFinishedInactivity",
        };
        this.ports.forEach((p) => p.postMessage(message));
    }
    sendLogInfo(date, messageWorker) {
        const message = {
            date: date,
            message: messageWorker,
            type: "LogInfo",
        };
        this.ports.forEach((p) => p.postMessage(message));
    }
}
//# sourceMappingURL=message-managers.js.map